export const WEEKEND_WARNING_TYPE = 'weekend';
export const MAX_DATE_EXCEEDED_WARNING_TYPE = 'maxDateExceeded';
export const CONTRACT_MAX_DAYS_EXCEEDED_WARNING_TYPE = 'contractMaxDaysExceeded';

const DATE_WARNING_TYPES = {
  WEEKEND: WEEKEND_WARNING_TYPE,
  MAX_DATE_EXCEEDED: MAX_DATE_EXCEEDED_WARNING_TYPE,
  CONTRACT_MAX_DAYS_EXCEEDED: CONTRACT_MAX_DAYS_EXCEEDED_WARNING_TYPE,
};

const DATE_WARNING_MESSAGES = {
  WEEKEND: 'Las fechas que caen un fin de semana o feriado, se moverán al siguiente día hábil',
  MAX_DATE_EXCEEDED: 'Las fechas que excedan el máximo, se seleccionará la fecha máxima permitida',
  CONTRACT_MAX_DAYS_EXCEEDED: (maxOperationDays) => `Excede plazo máximo permitido de ${maxOperationDays} días, si necesitas más plazo solicítalo con tu ejecutivo`,
};

export { DATE_WARNING_TYPES, DATE_WARNING_MESSAGES };
